import PropTypes from 'prop-types'

import { Checkbox, Typography } from '@material-ui/core'

import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from 'components/Table'
import { LoadingFeedback } from 'components'

import helpers from 'helpers'

const AvailablePreRegistrationsTable = ({
  availablePreRegistrations,
  isLoading,
  selectedIds,
  setSelectedIds,
}) => {
  const handleToggle = (preRegistrationId) => {
    setSelectedIds((current) =>
      current.includes(preRegistrationId)
        ? current.filter((id) => id !== preRegistrationId)
        : [...current, preRegistrationId],
    )
  }

  const coversAll =
    availablePreRegistrations.length > 0 &&
    selectedIds.length === availablePreRegistrations.length

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <Table
        size="small"
        emptyMessage="Nenhuma organização elegível foi encontrada."
      >
        <TableHead>
          <TableRow>
            <TableCell width="10%">Selecionar</TableCell>
            <TableCell width="20%">Tipo</TableCell>
            <TableCell width="40%">Organização</TableCell>
            <TableCell width="30%">Documento</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {availablePreRegistrations.map((item) => (
            <TableRow key={item?.preRegistration?.id}>
              <TableCell>
                <Checkbox
                  color="primary"
                  checked={selectedIds.includes(item?.preRegistration?.id)}
                  onChange={() => handleToggle(item?.preRegistration?.id)}
                />
              </TableCell>
              <TableCell>{item?.kindLabel}</TableCell>
              <TableCell>{item?.preRegistration?.name}</TableCell>
              <TableCell>
                {helpers.formatters.document.identify(
                  item?.preRegistration?.document,
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {coversAll && (
        <Typography variant="body2" color="error">
          A seleção não pode cobrir todas as organizações — use o escopo
          Completo nesse caso.
        </Typography>
      )}
    </>
  )
}

AvailablePreRegistrationsTable.propTypes = {
  availablePreRegistrations: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  selectedIds: PropTypes.array.isRequired,
  setSelectedIds: PropTypes.func.isRequired,
}

export default AvailablePreRegistrationsTable
